import React, { useEffect, useState } from 'react'
import { ErrorLabel } from '..'
import { formatDateToInput, validateDate } from '../../../_metronic/helpers'
import styles from './styles/Input.module.css'

interface IDateInputProps {
  type?: string
  /** Id do input, para associar um <label htmlFor>. */
  id?: string
  name?: string
  placeholder?: string
  value?: string | number | undefined
  required?: boolean
  className?: string
  disabled?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  maxDate?: string | Date
  errorMessage?: string
  isValid?: boolean
  isInvalid?: boolean
  minDate?: string
  'aria-invalid'?: boolean
  'aria-describedby'?: string
}

export const DateInput: React.FC<IDateInputProps> = ({
  placeholder = 'Digite a data inicial',
  value: initialValue = '',
  required = false,
  className = '',
  disabled = false,
  onChange,
  onBlur,
  maxDate,
  errorMessage,
  isInvalid,
  isValid,
  minDate,
  ...props
}) => {
  const [value, setValue] = useState(initialValue)
  const [localError, setLocalError] = useState<string>('')
  const [touched, setTouched] = useState(false)

  useEffect(() => setValue(initialValue), [initialValue])

  const max = maxDate ? formatDateToInput(maxDate) : undefined

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    setValue(newValue)
    setLocalError(validateDate(newValue, minDate, max))
    // Repassa sempre, válido ou não: segurar o valor aqui fazia a tela mostrar uma data e o
    // formulário guardar outra.
    onChange?.(e)
  }

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setTouched(true)
    onBlur?.(e)
  }

  // O erro local só aparece depois que o usuário sai do campo, para não piscar a cada dígito do ano.
  const showError = errorMessage || (touched && localError)

  const inputClasses = `
    form-control form-control-solid
    ${isInvalid || showError ? 'is-invalid' : isValid ? 'is-valid' : ''} 
    ${disabled ? styles.disabledInput : ''} 
    ${className}
  `.trim()

  return (
    <div className='w-100'>
      <input
        {...props}
        type='date'
        className={inputClasses}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        required={required}
        disabled={disabled}
        min={minDate}
        max={max}
      />
      {showError && <ErrorLabel>{showError}</ErrorLabel>}
    </div>
  )
}
